import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinJenisPetugas = createAsyncThunk(
  "jenispetugas/getMin",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMinMasterJenisPetugas",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getMinJenisPetugasSearch = createAsyncThunk(
  "jenispetugas/getMinSearch",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMinMasterJenisPetugas",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        let newObj = [];
        response.data.data.map((item) =>
          newObj.push({
            value: item.jenispetugasID,
            label: item.Namajenispetugas,
          })
        );
        return { data: newObj };
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getJenisPetugas = createAsyncThunk(
  "jenispetugas/get",
  async ({ start, count, search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMasterJenisPetugas",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertjenispetugas = createAsyncThunk(
  "jenispetugas/insert",
  async ({ jenisPetugas }, thunkAPI) => {
    let formData = new FormData();
    formData.append("jenisPetugas", jenisPetugas);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertMasterjenispetugas",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updatejenispetugas = createAsyncThunk(
  "jenispetugas/update",
  async ({ jenisPetugas, ID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("jenisPetugas", jenisPetugas);
    formData.append("ID", ID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateMasterjenispetugas",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

const initialState = {
  message: "",
  minData: [],
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
};

export const jenispetugasSlice = createSlice({
  name: "jenispetugas",
  initialState,
  reducers: {},
  extraReducers: {
    [getMinJenisPetugas.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minData = payload.data;
      return state;
    },
    [getMinJenisPetugas.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload.message;
    },
    [getMinJenisPetugas.pending]: (state) => {
      state.isMinFetching = true;
    },

    [getJenisPetugas.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getJenisPetugas.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload.message;
    },
    [getJenisPetugas.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertjenispetugas.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [insertjenispetugas.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload.message;
    },
    [insertjenispetugas.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updatejenispetugas.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [updatejenispetugas.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [updatejenispetugas.pending]: (state) => {
      state.isUpdateFetching = true;
    },
    // UPDATE
    [getMinJenisPetugasSearch.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.minData = payload.data;

      return state;
    },
    [getMinJenisPetugasSearch.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [getMinJenisPetugasSearch.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const jenispetugasSelector = (state) => state.jenispetugas;
